import { render, staticRenderFns } from "./PacksRedesign.vue?vue&type=template&id=0fb7d7c7"
import script from "./PacksRedesign.vue?vue&type=script&lang=js"
export * from "./PacksRedesign.vue?vue&type=script&lang=js"
import style0 from "./PacksRedesign.vue?vue&type=style&index=0&id=0fb7d7c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports